export default __webpack_public_path__ + "static/media/Ocean blues 1.0f90edb3.jpg";